import React from 'react';
import { Stack, Typography, Card } from 'investira.react.components';
import { validators } from 'investira.sdk';
import FundosAbertos from './FundosAbertos';
import Observacoes from './Observacoes';
import Consolidacao from './Consolidacao';
import RecursoGarantidor from './RecursoGarantidor';

const Highlights = props => {
  const { data } = props;

  const isEnquadrado = validators.isEmpty(data.response?.resumo.desenquadramentos);

  const isEnquadradoAlvo = validators.isEmpty(data.response?.resumo.desenquadramentos_alvo);

  return (
    <>
      <Stack direction="column" sx={{ gap: 1 }} component="section" flexGrow={1}>
        <Stack gap={1} flexGrow={1} direction={{ xs: 'column', md: 'row' }}>
          <Card
            sx={{
              display: 'flex',
              flex: 1,
              backgroundColor: isEnquadrado ? 'primary.main' : 'error.light'
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="secondary.main" sx={{ fontWeight: 500 }}>
                {isEnquadrado ? 'Enquadramento' : 'Não enquadrado'}
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h2" color="secondary.main" sx={{ fontWeight: 600 }}>
                    {!isEnquadrado
                      ? String(Object.keys(data.response.resumo.desenquadramentos).length).padStart(
                          2,
                          '0'
                        )
                      : 'OK!'}
                  </Typography>
                </Stack>

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="caption" color="secondary.main" sx={{ fontWeight: 500 }}>
                    {isEnquadrado
                      ? `Total de  ${data.response?.resumo.estatisticas.quantidade_regras} regras`
                      : `de ${data.response?.resumo.estatisticas.quantidade_regras} regras `}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>

          {data.response?.resumo.estatisticas.quantidade_regras_alvo > 0 && (
            <Card
              sx={{
                display: 'flex',
                flex: 1,
                backgroundColor: isEnquadradoAlvo ? 'primary.main' : 'warning.main' //
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="secondary.main" sx={{ fontWeight: 500 }}>
                  {isEnquadradoAlvo ? 'Enquadramento Alvo' : 'Alvo não enquadrado'}
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant="h2" color="secondary.main" sx={{ fontWeight: 600 }}>
                      {!isEnquadradoAlvo
                        ? String(
                            Object.keys(data.response.resumo.desenquadramentos_alvo).length
                          ).padStart(2, '0')
                        : 'OK!'}
                    </Typography>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between">
                    <Typography variant="caption" color="secondary.main" sx={{ fontWeight: 500 }}>
                      {isEnquadradoAlvo
                        ? `Total de ${data.response?.resumo.estatisticas.quantidade_regras_alvo} validações`
                        : `de ${data.response?.resumo.estatisticas.quantidade_regras_alvo} validações`}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          )}
        </Stack>
        <RecursoGarantidor data={data} />
        <Stack gap={1} flexGrow={0} direction={{ xs: 'column', md: 'row' }}>
          {!validators.isEmpty(data.request_metadata?.carteiras) && <Consolidacao data={data} />}
          <Card sx={{ flex: 1, display: 'flex' }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Ativos Analisados
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{data.response?.resumo.estatisticas.quantidade_ativos_analisados}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          {!validators.isEmpty(data.response?.resumo.erros) && <Observacoes data={data} />}
        </Stack>
        <Stack gap={1} flexGrow={0} direction={{ xs: 'column', md: 'row' }}>
          <FundosAbertos data={data} />
          <Card sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Fundos Analisados
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{data.response?.resumo.estatisticas.quantidade_fundos_analisados}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </>
  );
};

export default Highlights;
